import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { PanelInstrucionHands } from '../../../components/common/PanelInstrucionHands';
import { ModalInfoTextV2 } from '../../../components/common/ModalInfoTextV2';
import { voicesTypeControl } from '../../../types/audioType';
import { imgT9 } from '../../../assets/tema9';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	instructions: 3,
	modalOne: 4,
	modalTwo: 5,
	modalThree: 6,
	modalFour: 7,
	dialogTwo: 8,
	dialogThree: 9,
	dialogFour: 10,
	dialogFive: 11,
	dialogSix: 12,
	win: 13,
	hideUI: 100,

};

const stepThree = {
	modal_1: {
		ui: steps.modalOne,
		action: () => {

		}
	},
	modal_2: {
		ui: steps.modalTwo,
		action: () => {

		}
	},
	modal_3: {
		ui: steps.modalThree,
		action: () => {

		}
	},
	modal_4: {
		ui: steps.modalFour,
		action: () => {

		}
	},
}

export const Theme9SubtopicOneActivityTwo = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema9.activities.subtema1], 2);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 9 sub 1 act 2");
			ObserverEmitter.emit(EVENTS.tema9.topic1.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub2a01)
	})
	ObserverEmitter.on(EVENTS.tema9.topic1.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{[9, 10, 11, 12, 13].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema9.topic1.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 2: Riesgos en Tienda.' />
					<DialogBarNew
						dialog={`Gracias al área de SASSO, tenemos identificados los principales riesgos que existen en Tienda. Acompáñame y te contare cuáles son.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1. SASSO"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub2a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Haz clic en las áreas iluminadas, para conocer los principales riesgos en Tienda y cómo evitarlos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.instructions);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.instructions && (
				<>
					<PanelInstrucionHands
						text="Toca encima de el lugar iluminado para obtener más información."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema9.topic1.actScene, "touch_1")
							setUiToShow(steps.hideUI);
						}}
						img={imgT9.panel}
					/>
				</>
			)}

			{uiToShow === steps.modalOne && (
				<>
					<ModalInfoTextV2
						title="Sobreesfuerzos"
						description={`Causa: Realizar cargas de manera incorrecta.
						
						Para prevenir: Realiza las cargas de peso máximo permitido, con la fuerza de las piernas y brazos, la espalda siempre debe estar recta y la carga debe ir pegada al cuerpo. Evita realizar la actividad por tiempo prolongado y utiliza carritos para transportar las cargas.`}
						url={imgT9.modal_1}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema9.topic1.actScene, "touch_2")
							setUiToShow(steps.hideUI);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}

			{uiToShow === steps.modalTwo && (
				<>
					<ModalInfoTextV2
						title="Tropezones, caídas de escaleras y/o techos"
						description={`Causa: Subir al techo del cuarto frio, estibas de mas de 2 m de alto, mal uso de escaleras, objetos en piso, zapato con suela lisa, piso mojado.
						
						Para prevenir: Evita estibar la mercancía a mas de dos metros y no la coloques arriba de ningún elemento de la bodega (sanitarios, gabinetes eléctricos, anaqueles, tuberías).`}
						url={imgT9.modal_2}
						callback={() => {
							setUiToShow(steps.hideUI);
							ObserverEmitter.emit(EVENTS.tema9.topic1.actScene, "touch_3")
						}}
					>
					</ModalInfoTextV2>
				</>
			)}

			{uiToShow === steps.modalThree && (
				<>
					<ModalInfoTextV2
						title="Tropezones, caídas de escaleras y/o techos"
						description={`RECUERDA: Está prohibido subir mercancía u objetos arriba del cuarto frio.
						
						No uses la escalera cerrada, en mal estado y con objetos debajo para aumentar altura, usa la regla de los tres puntos (2 manos 1 pie, 2 pies una mano).
						
						Utiliza calzado con suela antiderrapante y siempre mantén el área limpia y libre de objetos.`}
						url={imgT9.modal_3}
						callback={() => {
							setUiToShow(steps.hideUI);
							ObserverEmitter.emit(EVENTS.tema9.topic1.actScene, "touch_4")
						}}
					>
					</ModalInfoTextV2>
				</>
			)}

			{uiToShow === steps.modalFour && (
				<>
					<ModalInfoTextV2
						title="Lesiones en manos"
						description={`Causa: Aplastamiento al manipular tómbola y mercancía, quemaduras por café, cortadas por cuchillos.
						
						Para prevenir: Utiliza ambas manos para manipular la tómbola, evita introducir los dedos al colocar le dinero en la tómbola. Recuerda realizar los pasos correctos para el cambio de café y así evitarás quemaduras, así mismo, utiliza los guantes para la manipulación del hielo y/o cuchillos.`}
						url={imgT9.modal_4}
						callback={() => {
							setUiToShow(steps.dialogThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub2a03)
							ObserverEmitter.emit(EVENTS.tema9.topic1.actScene, "return")
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`Pon mucha atención, lo que debes hacer en caso de un accidente de trabajo, trayecto o enfermedad.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub2a04)
							// ObserverEmitter.emit(EVENTS.characterAnimations.pensativo);
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Comunícate al Centro de Control, identifica el teléfono de tu Plaza a al reverso de tu gafete, ahí te apoyarán a atender cualquier emergencia en caso de accidente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub2a05)
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={`El reporte es una obligación legal del trabajador y debe notificarse a la empresa.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub2a06)
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`En el caso de lesiones sufridas por clientes, se reporta de inmediato para que se gestione la atención del caso desde un inicio.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.hideUI && (
				<>

				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Ahora conoces los principales riesgos en Tienda y cómo evitarlos."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema9.activities.subtema1
								})
							);
							navigator("/home9/tema9/subtema1/activityThree");
						}}
					/>
				</>
			)}
		</>
	)
}
